<div class="container max-w-2xl mx-auto p-6">
  <h2 class="text-3xl font-bold text-white mb-6">API Status</h2>
  
  @if (loading()) {
    <div class="relative min-h-[200px] rounded-lg overflow-hidden">
      <app-loading [showLogo]="false" [textValue]="'common.loading'"></app-loading>
    </div>
  }
  
  @if (error()) {
    <div class="bg-red-900/50 border border-red-700 rounded-lg p-4 text-red-200 mb-4">
      <p class="font-semibold">Error</p>
      <p>{{ error() }}</p>
    </div>
  }
  
  @if (apiResponse(); as response) {
    @if (!loading()) {
      <div class="bg-gray-800/50 border border-gray-700 rounded-lg p-6 text-white mb-6 shadow-lg">
        <div class="space-y-3">
          <div>
            <span class="text-gray-400 font-semibold">Status:</span>
            <span class="ml-2 text-green-400">{{ response.status }}</span>
          </div>
          <div>
            <span class="text-gray-400 font-semibold">Message:</span>
            <span class="ml-2">{{ response.message }}</span>
          </div>
          <div>
            <span class="text-gray-400 font-semibold">Timestamp:</span>
            <span class="ml-2 text-gray-300">{{ response.timestamp | date:'medium' }}</span>
          </div>
        </div>
      </div>
    }
  }
  
  <div class="flex justify-end">
    <button 
      (click)="fetchData()" 
      class="w-full bg-blue-800 hover:bg-blue-900 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="loading()">
      {{ loading() ? 'Loading...' : 'Refresh' }}
    </button>
  </div>
</div>